import { createFileRoute } from "@tanstack/react-router";
import AdminIPDetail from "@/pages/AdminIPDetail";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/ip-library/$id/")({
  component: () => (
    <RoleGate allow={['staff']} area="IP Library"><AdminIPDetail /></RoleGate>
  ),
});
